export const SERVICE_URL: string = process.env.SERVICE_URL;
export const SITE_URL: string = process.env.SITE_URL;
export const BLOB_URL: string = process.env.BLOB_URL;
export const QUOTE_URL: string = process.env.QUOTE_URL;
export const SPEND_URL: string = process.env.SPEND_URL;
export const ASSET_URL: string = process.env.ASSET_URL;
export const AUTH0_DOMAIN: string = process.env.AUTH0_DOMAIN;
export const AUTH0_AUDIENCE: string = process.env.AUTH0_AUDIENCE;
export const AUTH0_CLIENTID: string = process.env.AUTH0_CLIENTID;
export const AUTH0_SCOPE: string =
  "openid profile manage:images manage:addresses manage:orders";
export const DEFAULT_CAUSE_URL: string = process.env.DEFAULT_CAUSE_URL;

export const ALERT_TYPE_ERROR = "Error";
export const ALERT_TYPE_SUCCESS = "Success";

export const STORAGE_CODE_DETAILS = "STORAGE_CODE_DETAILS";
export const STORAGE_DONATIONS = "STORAGE_DONATIONS";
